var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"ripple",rawName:"v-ripple"}],ref:"cBtn",class:[
    'c-button d-inline-flex align-center justify-center rounded-50',
    {
      'bg-orange white--text-abs':
        !_vm.isSecondary && !_vm.shouldDisabled && !_vm.isDefault,
      'is-secondary has-hover-effect primary--text':
        _vm.isSecondary && !_vm.shouldDisabled,
      'border-default': !!_vm.shouldDisabled || !!_vm.isDefault,
      'is-short': _vm.isShort,
      'is-narrow': _vm.isNarrow,
      'disabled gray--text': _vm.shouldDisabled,
      'is-small': _vm.isSmall,
    } ],on:{"click":_vm.click}},[_c('div',{class:['font-weight-medium', { 'text-5': _vm.isSmall, 'text-4': !_vm.isSmall }]},[(!_vm.loading)?_vm._t("default"):_c('v-progress-circular',{attrs:{"indeterminate":"","size":"18","width":"2"}})],2)])}
var staticRenderFns = []

export { render, staticRenderFns }